import React from "react";
import { NavLink } from "react-router-dom";

export default function PortalSidebar({
  sections = [],
  open = false,
  onClose,
  routePrefix = "",
  activeColor = "#085398",
  activeBg = "#eef2ff",
}) {
  if (!sections || sections.length === 0) return null;

  return (
    <>
      <div
        className={`portal-sidebar-overlay ${!open ? "hidden" : ""}`}
        onClick={onClose}
      />
      <aside
        className={`portal-sidebar ${!open ? "closed" : ""}`}
        style={{ "--portal-sidebar-active-color": activeColor, "--portal-sidebar-active-bg": activeBg }}
      >
        {sections.map((section) => (
          <div key={section.title} className="portal-sidebar-section">
            <div className="portal-sidebar-section-title">{section.title}</div>
            <div className="portal-sidebar-items">
              {section.items.map(({ key, label, path, Icon, onClick, active }) => (
                onClick ? (
                  <button
                    key={key}
                    className={`portal-sidebar-link${active ? " active" : ""}`}
                    onClick={() => { onClick(key); if (onClose) onClose(); }}
                    type="button"
                  >
                    <span className="portal-sidebar-icon">
                      {Icon && <Icon size={18} />}
                    </span>
                    {label}
                  </button>
                ) : (
                  <NavLink
                    key={key}
                    to={`${routePrefix}${path}`}
                    className={({ isActive }) =>
                      `portal-sidebar-link${isActive ? " active" : ""}`
                    }
                    onClick={onClose}
                    end={path === "/dashboard" || path === "/"}
                  >
                    <span className="portal-sidebar-icon">
                      {Icon && <Icon size={18} />}
                    </span>
                    {label}
                  </NavLink>
                )
              ))}
            </div>
          </div>
        ))}
      </aside>
    </>
  );
}
